
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from "./authConfig";
import { msalConfigB2c, loginRequestB2c } from './authConfigB2c'
const msalInstanceB2b = new PublicClientApplication(msalConfig);
const msalInstanceB2c = new PublicClientApplication(msalConfigB2c);

let isSignInInProgress = false;

export const signIn = async (type, setToken) => {
    try {
        if (isSignInInProgress) {
            throw new Error('Sign-in operation is already in progress.');
        }
        isSignInInProgress = true;

        if (type === 'b2b') {
            await msalInstanceB2b.handleRedirectPromise();
            const response = await msalInstanceB2b.loginRedirect(loginRequest);
            setToken(response.accessToken);
            isSignInInProgress = false;
            return response.account;
        }
        else {
            await msalInstanceB2c.handleRedirectPromise();
            const response = await msalInstanceB2c.loginRedirect(loginRequestB2c);
            setToken(response.accessToken);
            isSignInInProgress = false;
            return response.account;
        }
    }
    catch (error) {
        isSignInInProgress = false;
        console.error('Error signing in:', error);
        throw error;
    }
};

export const signOut = async (type) => {
    if (type === 'b2b') {
        msalInstanceB2b.logoutRedirect();
    }
    else {
        msalInstanceB2c.logoutRedirect();
    }
};

// export const tokenRedirect = async (type) => {
//     const accessTokenRequest = {
//         ...(type == "b2b" ? loginRequest : loginRequestB2c),
//         account: accounts[0]
//     }
//     if (type === 'b2b') {
//         await msalInstanceB2b.acquireTokenRedirect(accessTokenRequest);
//     }
//     else {
//         await msalInstanceB2b.acquireTokenRedirect(accessTokenRequest);
//     }
// }

export const getToken = async (type, setToken) => {
    try {
        const accessToken = setToken();
        if (accessToken) {
            return accessToken;
        }

        if (type === 'b2b') {
            await msalInstanceB2b.handleRedirectPromise();
            const accounts = msalInstanceB2b.getAllAccounts();
            // console.log("b2b accounts", accounts);
            if (accounts.length === 0 && !isSignInInProgress) {
                const account = await signIn("b2b", setToken);
                return account.idToken;
            }
            // If there is an active account, try to acquire the token silently
            const account = accounts[0];
            const response = await msalInstanceB2b.acquireTokenSilent({
                ...loginRequest,
                account,
            });
            setToken(response.idToken);
            return response.idToken;
        }
        else {
            await msalInstanceB2c.handleRedirectPromise();
            const accounts = msalInstanceB2c.getAllAccounts();
            if (accounts.length === 0) {
                const account = await signIn("b2c", setToken);
                return account.idToken;
                // throw new Error('No accounts available for acquiring token silently.');
            }
            const account = accounts[0];
            const response = await msalInstanceB2c.acquireTokenSilent({
                ...loginRequestB2c,
                account,
            });
            setToken(response.idToken);
            return response.idToken;
        }

    } catch (error) {
        if (error.name === 'ServerError' && error.errorCode === 'access_denied' && error.errorMessage.includes('AADB2C90091')) {
            console.warn('User cancelled entering self-asserted information.');
            signOut(type);
            return "loginPage"
        }
        console.error('Error getting token:', error);
        throw error;
    }
};
